import extensibilityState from './store';
import { ExtensibilityHostItem } from './schema/ExtensibilityHostItem';

export default function getHostItem(hostItemIndex: string): ExtensibilityHostItem {
    return extensibilityState.HostItems.get(hostItemIndex);
}
